import React, { useState, useEffect } from "react";
import Grid from "../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DropDownGrid from "../Grid/Components/DropDownGrid";
import {
    Box,
    MenuItem,
    ListItemIcon
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Cookies from "universal-cookie";
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import FormContainer from "./Form/FormContainer";
import AssignAccountsDialog from "./AssignAccountsDialog";
import Title from "./Title";
import { selectRoles } from "../../reduxStore/RolesReducer";
import contractorAPI from "../../Network/Contractor";

const cookies = new Cookies();

export default function Contractors() {
    const maintheme = useSelector((state) => state.themeData.maintheme);
    const [t] = useTranslation("common");
    const [rows, setRows] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [loading, setLoading] = useState(false);

    const [pageCount, setPageCount] = useState(0);
    const [openFilterColumn, setOpenFilterColumn] = useState(false);
    const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);
    const [elementClicked, setElementClicked] = useState(null);

    const [filters, setFilters] = useState({
        name: "",
        code: "",
        account_ids: [],
        accounts_selected: [],
        enabled: null,
    })
    const [reload, setReload] = useState(false)

    const [openForm, setOpenForm] = useState(false);
    const [selectedObject, setselectedObject] = useState(null);
    const [openAssignDialog, setOpenAssignDialog] = useState(false);
    const [assignObject, setAssignObject] = useState(null);

    const handlePageChange = (newPage) => {
        setPageNumber(newPage + 1);
    };

    const navigate = useNavigate();
    const controller = new AbortController();
    const [rowsTotal, setRowsTotal] = useState(0);
    const screenwidth = useSelector((state) => state.settingsData.screenwidth);

    const rolesRedux = useSelector(selectRoles)

    const columns = [
        { field: "id", headerName: "#", minWidth: 50, maxWidth: 100 },
        { field: "name", headerName: t("CONTRACTORS.name") || "الاسم", minWidth: 110, maxWidth: 200, flex: 2 },
        { field: "code", headerName: t("CONTRACTORS.code") || "الكود", minWidth: 110, maxWidth: 150, flex: 2 },
        {
            field: "account_names",
            headerName: t("CONTRACTORS.account") || "الحسابات",
            minWidth: 150,
            maxWidth: 300,
            flex: 2,
            renderCell: (params) => {
                const accounts = params?.row?.account_names;
                if (!accounts) return null;
                const accountList = accounts.split(',').map(a => a.trim()).filter(a => a);
                if (accountList.length === 0) return null;
                return (
                    <div dir="rtl">
                        <ul style={{ margin: 0, paddingRight: 20, paddingLeft: 0, listStyleType: 'disc', textAlign: 'right' }}>
                            {accountList.map((account, index) => (
                                <li key={index} style={{ fontFamily: 'Cairo', fontSize: '13px' }}>{account}</li>
                            ))}
                        </ul>
                    </div>
                );
            }
        },
        {
            field: "enabled", headerName: t("CONTRACTORS.enabled") || "مفعل", minWidth: 110, maxWidth: 150, flex: 1,
            renderCell: (rows) => (
                <>
                    {rows?.row?.enabled ? (
                        <MenuItem
                            onClick={() => { }}
                            className="ActionIcons"
                        >
                            <ListItemIcon
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "0px 7px 0 0",
                                }}
                            >
                                <CheckCircleIcon style={{ fill: "#388e3c" }} />
                            </ListItemIcon>
                        </MenuItem>
                    ) : <MenuItem
                        onClick={() => { }}
                        className="ActionIcons"
                    >
                        <ListItemIcon
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "0px 7px 0 0",
                            }}
                        >
                            <DoDisturbOnIcon style={{ fill: "#d32f2f" }} />
                        </ListItemIcon>
                    </MenuItem>}
                </>
            )
        },
        {
            headerName: t("CONTRACTORS.actions") || "الإجراءات",
            field: "Actions",
            flex: 0.4,
            minWidth: 100,
            hide: !rolesRedux?.view_master?.value,
            renderCell: (rows) => (
                <DropDownGrid>
                    {
                        rolesRedux?.view_master?.value ?
                            <MenuItem onClick={() => { updateFunction(rows?.row) }} className="ActionIcons">
                                <ListItemIcon sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    margin: '0px 7px 0 0'
                                }}>
                                    <EditIcon style={{ fill: maintheme?.primary }} />
                                </ListItemIcon>
                                {t('GLOBAL.action_edit')}
                            </MenuItem> : null}
                    {
                        rolesRedux?.view_master?.value ?
                            <MenuItem onClick={() => { openAssignAccounts(rows?.row) }} className="ActionIcons">
                                <ListItemIcon sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    margin: '0px 7px 0 0'
                                }}>
                                    <AssignmentIcon style={{ fill: maintheme?.secondary || '#1976d2' }} />
                                </ListItemIcon>
                                {t('GLOBAL.action_assign_accounts')}
                            </MenuItem> : null}
                </DropDownGrid>
            ),
        },
    ]

    useEffect(() => {
        loadData()
    }, [pageNumber, pageSize, reload]);

    const loadData = async (searchParams) => {
        if (
            cookies.get("active_session") &&
            cookies.get("active_session") == "yes"
        ) {
            let object = {
                username: cookies.get("user_name") ? cookies.get("user_name") : null,
                user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
                account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
                account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
                authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
                sid: cookies.get("sid") ? cookies.get("sid") : null,
                baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
                id: cookies.get("id") ? cookies.get("id") : null,
                page: pageNumber,
                page_size: pageSize,
                search: "",
                ...searchParams,
                name: filters?.name,
                code: filters?.code,
                enabled: filters?.enabled,
                account_ids: filters?.account_ids?.length > 0 ? JSON.stringify(filters.account_ids) : null,
            };

            setLoading(true);

            const result = await contractorAPI.getContractors({
                params: object,
                signal: controller?.signal,
            });
            setLoading(false);

            if (result.status && result?.data?.data?.data) {
                if (result?.data?.data?.data?.length > 0) {
                    setRows(result?.data?.data?.data);
                    setRowsTotal(result?.data?.data?.total_records);
                    setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
                }
                else {
                    setRows([]);
                    setRowsTotal(0);
                    setPageCount(0);
                }
            } else {
                if (result?.data?.data?.message) {
                    toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
                }
                else if (!result?.data?.error) {
                    toast.error(t("NETWORK_MESSAGES.unknownError"));
                    return;
                }
                if (result && result?.data && result?.data?.data?.message) {
                    if (result?.data?.data?.message?.text == "unauthorized to complete") {
                        navigate("/redirect");
                    }
                }
            }
            setLoading(false);
        } else {
            navigate("/redirect");
        }
    };

    const createFunction = () => {
        setselectedObject(null);
        setOpenForm(true);
    };
    const updateFunction = (obj) => {
        setselectedObject(obj)
        setOpenForm(true)
    }
    const openAssignAccounts = (obj) => {
        setAssignObject(obj);
        setOpenAssignDialog(true);
    }

    const clearFilterFunction = () => {
        setFilters({
            name: "",
            code: "",
            account_ids: [],
            accounts_selected: []
        })
    }
    const searchFunction = () => {
        setReload(!reload)
        setPageNumber(1)
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                justifyContent: "center",
                alignItems: "start",
                overflowX: "hidden",
                "& .MuiChip-label": {
                    fontFamily: "Cairo-Medium",
                },
            }}
        >
            {openForm ? (
                <FormContainer
                    object={selectedObject}
                    openForm={openForm}
                    setOpenForm={setOpenForm}
                    loadData={loadData}
                />
            ) : null}

            <AssignAccountsDialog
                open={openAssignDialog}
                setOpen={setOpenAssignDialog}
                contractor={assignObject}
                onSave={() => loadData()}
            />

            <Title
                createFunction={createFunction}
                openFilterColumn={openFilterColumn}
            />
            <Grid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                loading={loading}
                handlePageChange={handlePageChange}
                rowsTotal={rowsTotal}
                checkScreenSize={screenwidth}
                pageCount={pageCount}
                openFilterColumn={openFilterColumn}
                elementClicked={elementClicked}
                setOpenFilterColumn={setOpenFilterColumn}
                setColumnFilterValue={setOpenFilterColumnValue}
                columFilterValue={openFilterColumnValue}
                clearFunction={clearFilterFunction}
                searchFunction={searchFunction}
                hasCreate={false}
                creatFunction={createFunction}
                filterChilds={
                    <Search
                        filters={filters}
                        setFilters={setFilters}
                    />
                }
            />
        </Box>
    );
}
